/**
 * MultiModelPostDisplay Component
 * Feature 014: Unified Multi-AI Post Generation Flow
 * T043: Dynamic 1-3 column layout for comparing AI-generated posts
 */

import { memo } from 'react';
import { ModelColumnMemo } from './ModelColumn';
import type { IMultiModelPosts, ModelKey } from '../../@types/posts';

interface IMultiModelPostDisplayProps {
  selectedModels: ModelKey[]; // NEW: Dynamic list of 1-3 models
  generatedPosts: IMultiModelPosts;
  generationStatus: Partial<Record<ModelKey, 'idle' | 'loading' | 'completed' | 'error'>>;
  selectedVariantModel: ModelKey | null; // NEW: Which variant user selected
  isSelecting: boolean; // NEW: Loading state during selection
  onSelectBestVariant: (modelKey: ModelKey) => void; // NEW: Selection callback
}

const MultiModelPostDisplay = ({
  selectedModels,
  generatedPosts,
  generationStatus,
  selectedVariantModel,
  isSelecting,
  onSelectBestVariant,
}: IMultiModelPostDisplayProps) => {
  // Dynamic grid class based on model count
  const gridClass =
    selectedModels.length === 1
      ? 'grid grid-cols-1 gap-6'
      : selectedModels.length === 2
        ? 'grid grid-cols-1 gap-6 lg:grid-cols-2'
        : 'grid grid-cols-1 gap-6 lg:grid-cols-3';

  // Helper to get model display name
  const getModelName = (modelKey: ModelKey): string => {
    if (modelKey === 'claude') return 'Claude Opus 4.6';
    if (modelKey === 'gemini') return 'Gemini 3.1 Pro';
    return 'GPT-5.4';
  };

  return (
    <div className={gridClass}>
      {selectedModels.map(modelKey => (
        <ModelColumnMemo
          key={modelKey}
          modelKey={modelKey}
          modelName={getModelName(modelKey)}
          postData={generatedPosts[modelKey]}
          status={generationStatus[modelKey] ?? 'idle'}
          selectedVariantModel={selectedVariantModel}
          isSelecting={isSelecting}
          onSelectBestVariant={onSelectBestVariant}
        />
      ))}
    </div>
  );
};

export const MultiModelPostDisplayMemo = memo(MultiModelPostDisplay);
